import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Link from 'flarum/common/components/Link';
import Tooltip from 'flarum/common/components/Tooltip';
import Avatar from 'flarum/common/components/Avatar';
import Icon from 'flarum/common/components/Icon';
import SubtreeRetainer from 'flarum/common/utils/SubtreeRetainer';
export default class Voters extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "subtreeRetainer", void 0);
    _defineProperty(this, "lastRenderVotes", -1);
    _defineProperty(this, "loading", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = !this.attrs.post.upvotes();
    if (this.loading) {
      this.load();
    }
    this.subtreeRetainer = new SubtreeRetainer(() => this.loading, () => this.attrs.post.votes(), () => {
      var _this$attrs$post, _this$attrs$post$upvo;
      return (_this$attrs$post = this.attrs.post) == null || (_this$attrs$post$upvo = _this$attrs$post.upvotes) == null || (_this$attrs$post$upvo = _this$attrs$post$upvo.call(_this$attrs$post)) == null ? void 0 : _this$attrs$post$upvo.length;
    });
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    return this.subtreeRetainer.needsRebuild();
  }
  onupdate() {
    if (this.lastRenderVotes !== this.attrs.post.votes()) {
      this.loading = true;
      setTimeout(() => m.redraw(), 0);
      this.lastRenderVotes = this.attrs.post.votes();
      this.load();
    }
  }
  view() {
    // @ts-ignore
    if (this.attrs.post.votes() === false || this.attrs.post.upvotes() === false) {
      return m("div", {
        className: "VotingContainer"
      }, m("div", {
        className: "FoFGamification-voters"
      }, m("div", {
        className: "FoFGamification-voters-title"
      }, m("span", {
        className: "FoFGamification-voters-title-icon"
      }, m(Icon, {
        name: "fas fa-users"
      }), m("span", {
        className: "FoFGamification-voters-title-label"
      }, app.translator.trans('fof-gamification.forum.voters.label')), m("span", {
        className: "FoFGamification-voters-title-label FoFGamification-voters-title-label--mobile"
      }, app.translator.trans('fof-gamification.forum.voters.label')))), m(LoadingIndicator, {
        display: "inline"
      })));
    }
    const max = 15;
    const voters = this.attrs.post.upvotes();
    return m("div", {
      className: "VotingContainer"
    }, m("div", {
      className: "FoFGamification-voters"
    }, m("div", {
      className: "FoFGamification-voters-title"
    }, m("span", {
      className: "FoFGamification-voters-title-icon"
    }, m(Icon, {
      name: "fas fa-users"
    }), m("span", {
      className: "FoFGamification-voters-title-label"
    }, app.translator.trans('fof-gamification.forum.voters.label')), m("span", {
      className: "FoFGamification-voters-title-label FoFGamification-voters-title-label--mobile"
    }, voters.length === 0 ? app.translator.trans('fof-gamification.forum.voters.label_none') : app.translator.trans('fof-gamification.forum.voters.label')))), m("div", {
      className: "FoFGamification-voters-message"
    }, voters.length === 0 ? app.translator.trans('fof-gamification.forum.voters.none') : null), m("div", {
      className: "FoFGamification-voters-list"
    }, voters.slice(0, max).map(user => m(Link, {
      href: app.route('user', {
        username: user.slug()
      }),
      className: "FoFGamification-voters-item"
    }, m(Tooltip, {
      text: user.displayName()
    }, m(Avatar, {
      user: user
    })))), voters.length > max ? m("span", {
      className: "FoFGamification-voters-item FoFGamification-voters-item--plus"
    }, m("span", {
      className: "Avatar"
    }, "+".concat(voters.length - max))) : null)));
  }
  async load() {
    const postId = this.attrs.post.id();
    if (!postId) return;
    await app.store.find('posts', postId, {
      include: 'upvotes'
    });
    this.loading = false;
    m.redraw();
  }
}
flarum.reg.add('fof-gamification', 'forum/components/Voters', Voters);